<template>
  <div class="mt-4  px-5">
    <h2>Genehmigungen</h2>

    <v-alert dense text type="info">
      <b>Tipp:</b>
      <div>
        Hier werden Einträge angezeigt, die euch Eure Mitglieder zur Freigabe
        einreichen.<br />
        Um ein Training zu bestätigen klickt auf freigabe.
      </div>
    </v-alert>

    <!-- Vereins-Auswahl bei mehreren VAdmin-Vereinen -->
    <v-select
      v-if="comp_isUserLoggedIn && comp_vadminClubs.length > 1"
      v-model="selected_club_id"
      :items="comp_vadminClubs"
      item-text="name"
      item-value="id"
      label="Verein auswählen"
      outlined
      dense
      class="mb-4"
      @change="getShootingbook"
    ></v-select>

    <v-data-table
      :headers="headers"
      :items="comp_filteredApproval"
      sort-by="nummer"
      class="elevation-1"
      ref="Shootingbook"
      :loading="loading"
    >
      <template v-slot:top>
        <v-toolbar flat dense color="success" dark>
          <v-toolbar-title>Genehmigungen</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="getShootingbook">
            <v-icon>mdi-reload</v-icon>
          </v-btn>
        </v-toolbar>

        <div class="pa-3" style="border-bottom: 1px solid rgba(0,0,0,.12);">
          <div class="d-flex flex-wrap align-center" style="gap: 12px;">
            <v-text-field
              v-model="search"
              label="Suche (Name, Waffe, Stand, ...)"
              prepend-inner-icon="mdi-magnify"
              outlined
              dense
              clearable
              hide-details
              style="flex: 1 1 220px; min-width: 200px;"
            ></v-text-field>
            <v-select
              v-model="filter_range_id"
              :items="comp_Ranges"
              item-text="text"
              item-value="id"
              label="Stand"
              outlined
              dense
              hide-details
              clearable
              style="flex: 0 1 180px; min-width: 150px;"
            ></v-select>
            <div
              class="d-flex"
              style="gap: 12px; flex: 1 1 320px; min-width: 0;"
            >
              <v-text-field
                v-model="date_from"
                label="Von"
                type="date"
                outlined
                dense
                hide-details
                style="flex: 1 1 0; min-width: 0;"
              ></v-text-field>
              <v-text-field
                v-model="date_to"
                label="Bis"
                type="date"
                outlined
                dense
                hide-details
                style="flex: 1 1 0; min-width: 0;"
              ></v-text-field>
            </div>
            <v-switch
              v-if="comp_canFilterMine"
              v-model="filter_mine"
              label="Nur meine"
              dense
              hide-details
              class="mt-0"
            ></v-switch>
            <v-btn text small @click="resetFilters">
              <v-icon left small>mdi-filter-off</v-icon>
              Zurücksetzen
            </v-btn>
            <span class="caption grey--text">
              {{ comp_filteredApproval.length }}/{{
                comp_ShootingbookforApproval.length
              }}
            </span>
          </div>
        </div>
      </template>

      <template v-slot:item.shooting_function_name="{ item }">
        <span>{{
            item.shooting_function_name || item.Aufsicht || item.funktion_name
          }}</span>
      </template>

      <template v-slot:item.schiessleiter="{ item }">
        <span v-if="item.schiessleiter_name || item.schiessleiter_vorname">
          {{
            item.schiessleiter_name
          }}{{
            item.schiessleiter_vorname ? ", " + item.schiessleiter_vorname : ""
          }}
        </span>
        <span v-else class="grey--text">—</span>
      </template>

      <template v-slot:item.beginn="{ item }">
        <span>{{
            new Date(item.beginn.replace(" ", "T")).toLocaleString()
          }}</span>
      </template>
      <template v-slot:item.ende="{ item }">
        <span>{{
            new Date(item.ende.replace(" ", "T")).toLocaleString()
          }}</span>
      </template>

      <template v-slot:item.approval="{ item }">
        <div v-if="item.bestaetigung_status === 1" class="d-flex">
          <v-btn
            color="success"
            small
            class="mr-1"
            :disabled="comp_isUserLoggedIn && !selected_club_id"
            @click="setApproval(item)"
          >
            <v-icon x-small class="mr-1">fas fa-check</v-icon>
            Freigabe
          </v-btn>
          <v-btn
            color="error"
            small
            :disabled="comp_isUserLoggedIn && !selected_club_id"
            @click="openRejectDialog(item)"
          >
            <v-icon x-small class="mr-1">fas fa-times</v-icon>
            Ablehnen
          </v-btn>
        </div>
      </template>

      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">
          Reset
        </v-btn>
      </template>
    </v-data-table>

    <!-- Ablehnen Dialog -->
    <v-dialog v-model="dialogReject" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Eintrag ablehnen</v-card-title>
        <v-card-text>
          <v-textarea
            v-model="abgelehnt_grund"
            label="Begründung (optional)"
            outlined
            rows="3"
            auto-grow
            hide-details="auto"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="closeRejectDialog"
          >Abbrechen
          </v-btn>
          <v-btn color="error" @click="confirmReject">Ablehnen</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "authorization",
  data() {
    const fmt = d => {
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    };
    const today = new Date();
    const weekAgo = new Date();
    weekAgo.setDate(today.getDate() - 7);

    return {
      loading: false,
      selected_club_id: null,
      dialogReject: false,
      reject_item: {},
      abgelehnt_grund: "",
      search: "",
      filter_range_id: null,
      date_from: fmt(weekAgo),
      date_to: fmt(today),
      filter_mine: false,
      headers: [
        {
          align: "Name",
          sortable: false
        },
        { text: "Name", value: "name" },
        { text: "Vorname", value: "vorname" },
        { text: "Stand", value: "KurzBez" },
        { text: "Bahn", value: "bahn" },
        { text: "Funktion", value: "shooting_function_name" },
        { text: "Schießleiter", value: "schiessleiter" },
        { text: "Waffe", value: "KurzT" },
        { text: "Disziplin", value: "LangBez" },
        { text: "Begin", value: "beginn" },
        { text: "Ende", value: "ende" },
        { text: "Verein freigabe", value: "approval", sortable: false }
      ]
    };
  },

  computed: {
    comp_ShootingbookforApproval() {
      return this.$store.state.ClubApp.ShootingbookApproval;
    },
    comp_Ranges() {
      // Stände aus den Approval-Einträgen ableiten und gruppieren
      const map = new Map();
      this.comp_ShootingbookforApproval.forEach(item => {
        if (
          item.shootingrange_id !== null &&
          item.shootingrange_id !== undefined
        ) {
          const id = item.shootingrange_id;
          if (!map.has(id)) {
            map.set(id, { id, text: item.KurzBez || `Stand ${id}` });
          }
        }
      });
      return Array.from(map.values()).sort((a, b) =>
        String(a.text).localeCompare(String(b.text))
      );
    },
    comp_filteredApproval() {
      let data = this.comp_ShootingbookforApproval;

      if (this.search && this.search.trim()) {
        const s = this.search.toLowerCase().trim();
        data = data.filter(
          item =>
            (item.name && item.name.toLowerCase().includes(s)) ||
            (item.vorname && item.vorname.toLowerCase().includes(s)) ||
            (item.KurzBez && item.KurzBez.toLowerCase().includes(s)) ||
            (item.KurzT && item.KurzT.toLowerCase().includes(s)) ||
            (item.LangBez && item.LangBez.toLowerCase().includes(s)) ||
            (item.shooting_function_name &&
              item.shooting_function_name.toLowerCase().includes(s)) ||
            (item.Aufsicht && item.Aufsicht.toLowerCase().includes(s)) ||
            (item.funktion_name &&
              item.funktion_name.toLowerCase().includes(s)) ||
            (item.schiessleiter_name &&
              item.schiessleiter_name.toLowerCase().includes(s)) ||
            (item.schiessleiter_vorname &&
              item.schiessleiter_vorname.toLowerCase().includes(s))
        );
      }

      if (this.filter_range_id !== null && this.filter_range_id !== undefined) {
        data = data.filter(
          item => String(item.shootingrange_id) === String(this.filter_range_id)
        );
      }

      if (this.date_from) {
        const from = new Date(this.date_from + "T00:00:00");
        data = data.filter(
          item => new Date(item.beginn.replace(" ", "T")) >= from
        );
      }

      if (this.date_to) {
        const to = new Date(this.date_to + "T23:59:59");
        data = data.filter(
          item => new Date(item.beginn.replace(" ", "T")) <= to
        );
      }

      if (this.filter_mine) {
        data = data.filter(item => item.is_my_schiessleiter_entry === true);
      }

      return data;
    },
    comp_canFilterMine() {
      return this.comp_ShootingbookforApproval.some(item =>
        Object.prototype.hasOwnProperty.call(item, "is_my_schiessleiter_entry")
      );
    },
    comp_isUserLoggedIn() {
      return this.$store.getters["UserAuth/isLoggedIn"];
    },
    comp_vadminClubs() {
      const clubs = this.$store.state.UserApp.Clubs;
      if (clubs && clubs.meineVereine) {
        return clubs.meineVereine.filter(
          v => v.pivot && v.pivot.isVAdmin === 1
        );
      }
      return [];
    }
  },

  mounted() {
    if (this.comp_isUserLoggedIn) {
      this.tryAutoSelectClub();
    } else {
      this.getShootingbook();
    }
  },

  watch: {
    comp_vadminClubs() {
      if (this.comp_isUserLoggedIn && !this.selected_club_id) {
        this.tryAutoSelectClub();
      }
    }
  },

  methods: {
    tryAutoSelectClub() {
      const clubs = this.comp_vadminClubs;
      if (clubs.length === 1) {
        this.selected_club_id = clubs[0].id;
        this.getShootingbook();
      }
      // Bei mehreren Vereinen: Benutzer wählt im Dropdown
    },
    getShootingbook() {
      const club_id = this.comp_isUserLoggedIn ? this.selected_club_id : null;
      this.$store.dispatch("ClubApp/getShootingbookforApproval", club_id);
    },
    resetFilters() {
      const fmt = d => {
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, "0");
        const dd = String(d.getDate()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd}`;
      };
      const today = new Date();
      const weekAgo = new Date();
      weekAgo.setDate(today.getDate() - 7);

      this.search = "";
      this.filter_range_id = null;
      this.date_from = fmt(weekAgo);
      this.date_to = fmt(today);
      this.filter_mine = false;
    },
    setApproval(item) {
      this.loading = true;
      const Data = {
        freigabeID: item.id,
        freigabebool: true,
        club_id: this.selected_club_id
      };
      this.$store
        .dispatch("ClubApp/setShootingRecordApproval", Data)
        .then(() => {
          this.loading = false;
        });
    },
    openRejectDialog(item) {
      this.reject_item = item;
      this.abgelehnt_grund = "";
      this.dialogReject = true;
    },
    closeRejectDialog() {
      this.dialogReject = false;
      this.reject_item = {};
      this.abgelehnt_grund = "";
    },
    confirmReject() {
      this.loading = true;
      const Data = {
        freigabeID: this.reject_item.id,
        freigabebool: false,
        club_id: this.selected_club_id,
        abgelehnt_grund: this.abgelehnt_grund || null
      };
      this.$store
        .dispatch("ClubApp/setShootingRecordApproval", Data)
        .then(() => {
          this.loading = false;
          this.closeRejectDialog();
        });
    },
    initialize() {
      this.getShootingbook();
    }
  }
};
</script>

<style scoped></style>